import { render, staticRenderFns } from "./PortlandCityNotices.vue?vue&type=template&id=20c87485&scoped=true&"
import script from "./PortlandCityNotices.vue?vue&type=script&lang=js&"
export * from "./PortlandCityNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c87485",
  null
  
)

export default component.exports